import ReactMarkdown from 'react-markdown';
import { STATUS } from 'consts';
import { useWaiver } from './useWaiver';
import waiverBgImg from 'img/waiver-bg.png';

export function Waiver() {
	const { status, t } = useWaiver();
	return (
		<div className="waiver">
			<div className="container">
				<div className="row">
					<div className="col-12 col-md-6 d-flex flex-column justify-content-center">
						{STATUS.SUCCESS === status && (
							<div className="txt-fix">
								<p className="display-3 text-white">{t('waiver_title')}</p>
								<ReactMarkdown className="text-white">{t('waiver_main')}</ReactMarkdown>
							</div>
						)}
						{STATUS.ERROR === status && <p className="txt-fix display-3 text-primary">{t('default_api_error')}</p>}
						{STATUS.NO_ID === status && <p className="txt-fix display-3 text-primary">{t('waiver_no_token_error')}</p>}
					</div>
					<div className="d-none d-md-block col-6 mt-3">
						<img src={waiverBgImg} alt="" className="img-fluid" />
					</div>
				</div>
			</div>
		</div>
	);
}
